import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "danger-icon",
  role: "img",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M8 5.31974C8.27614 5.31974 8.5 5.5436 8.5 5.81974V7.99998C8.5 8.27613 8.27614 8.49998 8 8.49998C7.72386 8.49998 7.5 8.27613 7.5 7.99998V5.81974C7.5 5.5436 7.72386 5.31974 8 5.31974Z" }, null, -1),
    _createElementVNode("path", { d: "M7.91108 9.91355C7.93992 9.90838 7.96962 9.90568 7.99995 9.90568C8.33576 9.90568 8.60799 10.1779 8.60799 10.5137C8.60799 10.8495 8.33576 11.1218 7.99995 11.1218H7.99083C7.66334 11.1158 7.39929 10.8517 7.39332 10.5242L7.39327 10.5213C7.39124 10.3591 7.45427 10.2028 7.56827 10.0874C7.66124 9.99326 7.78179 9.9327 7.91108 9.91355Z" }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M1.5 8C1.5 11.5901 4.40986 14.5 8 14.5C11.5901 14.5 14.5 11.5901 14.5 8C14.5 4.40986 11.5901 1.5 8 1.5C4.40986 1.5 1.5 4.40986 1.5 8ZM2.5 8C2.5 4.96214 4.96214 2.5 8 2.5C11.0379 2.5 13.5 4.96214 13.5 8C13.5 11.0379 11.0379 13.5 8 13.5C4.96214 13.5 2.5 11.0379 2.5 8Z"
    }, null, -1)
  ])))
}
export default { render: render }